import axios from "axios";
import _find from "lodash/find";
import _replace from "lodash/replace";
import api from "../config/api";
import TableHead from "../../templates/partials/TableHead.vue";
import data from "../lib/sharedComponentData";
import methods from "../lib/sharedComponentMethods";
import LocalStorageService from "../lib/LocalStorageService";

const team = {
  name: "Team",
  props: ["periodIndex", "id"],
  data() {
    return Object.assign(
      {
        teamActionAndEvents: [],
        teamPeriod: {},
        teamReporting: {},
        reporting: [],
        name: "",
        intervalId: null,
        errors: [],
        seminarType: LocalStorageService.getSeminarType() || "",
      },
      data
    );
  },
  mounted() {
    this.getTeamReporting();
    this.intervalId = this.startPolling(["getTeamReporting"]);
    this.getTeam();
  },
  destroyed() {
    this.stopPolling(this.intervalId);
  },
  methods: Object.assign(
    {
      getTeam() {
        axios
          .get(
            `${api.getUrl()}/api/frontend/team/${this.id}`
          )
          .then(response => {
            this.name = response.data.name;
          })
          .catch(err => {
            console.error("getTeam error", err);
            if (!this.errors) this.errors = [];
            this.errors.push(err);
          });
      },
      getTeamReporting() {
        axios
          .get(`${api.getUrl()}/api/frontend/reporting/?pIndex=${this.periodIndex}`)
          .then(response => {
            this.reporting = response.data.report;
            const teamReporting = this.reporting.find(
              t => t.id === parseInt(this.id)
            );

            if (!teamReporting) {
              console.warn("getTeamReporting: kein Team für id gefunden", this.id);
              this.teamReporting = null;
              this.teamActionAndEvents = [];
              return;
            }

            this.teamReporting = teamReporting.period;
            this.teamFlatInfo();
          })
          .catch(err => {
            console.error("getTeamReporting error", err);
            if (!this.errors) this.errors = [];
            this.errors.push(err);
          });
      },
      teamFlatInfo() {
        if (!Array.isArray(this.teamActionAndEvents)) {
          this.teamActionAndEvents = [];
        }

        if (!this.teamReporting) {
          console.warn("teamFlatInfo: teamReporting fehlt", this.teamReporting);
          this.teamActionAndEvents = [];
          return;
        }

        const actions = Array.isArray(this.teamReporting.action)
          ? this.teamReporting.action
          : [];
        const events = Array.isArray(this.teamReporting.event)
          ? this.teamReporting.event
          : [];

        // only adds the things to the list if they are not yet in there
        actions.forEach(action => {
          if (
            _find(this.teamActionAndEvents, a => a.id === action.id) ===
            undefined
          ) {
            this.teamActionAndEvents.push(action);
          }
        });
        events.forEach(event => {
          if (
            _find(this.teamActionAndEvents, a => a.id === event.id) ===
            undefined
          ) {
            this.teamActionAndEvents.push(event);
          }
        });

        if (this.teamActionAndEvents.length === 0) {
          return; // nichts zu berechnen
        }

        this.teamActionAndEvents.sort((a1, a2) => a1.id - a2.id); // TODO: Maybe sort by .created instead of pk
      },
      addPlus(value) {
        if (value <= 0) {
          return "";
        }
        return "+";
      },
      computeDifference(
        valueArray,
        currentIndex,
        valueType,
        toFixed = false,
        fixed = 2,
        division = false,
        divisor = 1
      ) {
        const oldValue = valueArray[currentIndex - 1];
        const newValue = valueArray[currentIndex];
        let r = newValue[valueType];
        if (currentIndex > 0) {
          r = newValue[valueType] - oldValue[valueType];
        }
        if (division) {
          r /= divisor;
        }
        if (toFixed) {
          r = r.toFixed(fixed);
        }
        if (currentIndex > 0) {
          return _replace(`${this.addPlus(r)}${r}`, ".", ",");
        }
        return _replace(r, ".", ",");
      }
    },
    methods
  ),
  components: {
    "table-head": TableHead
  }
};

export default team;
